import { defineMessages } from 'react-intl';

// Exposes i18n messages for the search result type component.
export const messages: {
	liveDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	page: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blogpost: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	whiteboard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	slide: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	database: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	space: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	comment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	folder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	calendar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	space_calendar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	question: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	answer: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	embed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	board: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dashboard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	plan: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	project: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	learning: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unrecognised: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- message key name, not global document
	document: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spreadsheet: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	presentation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'sharepoint-document': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	message: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	repository: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'pull-request': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	branch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	file: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	channel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	component: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'work-item': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	card: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	incident: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	focus_area: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	focus_area_status_update: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	organization: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	organization_status_update: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ask: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	email: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gliffy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'customer-org': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'data-table': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'customer-contact': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	object: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	schema: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	type: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	position: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	video: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	task: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	epic: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bug: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	story: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'sub-task': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subtask: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	improvement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'new feature': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	change: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	problem: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'service request': {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	liveDoc: {
		id: 'live_doc_type',
		defaultMessage: 'Live Doc',
		description: 'Type label for live document search result type',
	},
	page: {
		id: 'search_result_type_page',
		defaultMessage: 'Page',
		description: 'Label for the page search result type',
	},
	blogpost: {
		id: 'search_result_type_blogpost',
		defaultMessage: 'Blog Post',
		description: 'Label for the blog post search result type',
	},
	whiteboard: {
		id: 'search_result_type_whiteboard',
		defaultMessage: 'Whiteboard',
		description: 'Label for the whiteboard search result type',
	},
	slide: {
		id: 'search_result_type_slide',
		defaultMessage: 'Slides',
		description: 'Label for the slides (Confluence Slides) search result type',
	},
	database: {
		id: 'search_result_type_database',
		defaultMessage: 'Database',
		description: 'Label for the database search result type',
	},
	space: {
		id: 'search_result_type_space',
		defaultMessage: 'Space',
		description: 'Label for the space search result type',
	},
	attachment: {
		id: 'search_result_type_attachment',
		defaultMessage: 'Attachment',
		description: 'Label for the attachment search result type',
	},
	comment: {
		id: 'search_result_type_comment',
		defaultMessage: 'Comment',
		description: 'Label for the comment search result type',
	},
	folder: {
		id: 'search_result_type_folder',
		defaultMessage: 'Folder',
		description: 'Label for the folder search result type',
	},
	calendar: {
		id: 'search_result_type_calendar',
		defaultMessage: 'Calendar',
		description: 'Label for the calendar search result type',
	},
	space_calendar: {
		// snake_case returned by the API
		id: 'search_result_type_space_calendar',
		defaultMessage: 'Space calendar',
		description: 'Label for the space calendar search result type',
	},
	question: {
		id: 'search_result_type_question',
		defaultMessage: 'Question',
		description: 'Label for the question search result type',
	},
	answer: {
		id: 'search_result_type_answer',
		defaultMessage: 'Answer',
		description: 'Label for the answer search result type',
	},
	embed: {
		id: 'search_result_type_embed',
		defaultMessage: 'Smart Link',
		description: 'Label for the smart link result type',
	},
	board: {
		id: 'search_result_type_board',
		defaultMessage: 'Board',
		description: 'Label for the board search result type',
	},
	dashboard: {
		id: 'search_result_type_dashboard',
		defaultMessage: 'Dashboard',
		description: 'Label for the dashboard search result type',
	},
	filter: {
		id: 'search_result_type_filter',
		defaultMessage: 'Filter',
		description: 'Label for the filter search result type',
	},
	issue: {
		id: 'search_result_type_issue',
		defaultMessage: 'Work item',
		description: 'Label for the work item search result type',
	},
	plan: {
		id: 'search_result_type_plan',
		defaultMessage: 'Plan',
		description: 'Label for the plan search result type',
	},
	project: {
		id: 'search_result_type_project',
		defaultMessage: 'Project',
		description: 'Label for the project search result type',
	},
	goal: {
		id: 'search_result_type_goal',
		defaultMessage: 'Goal',
		description: 'Label for the goal search result type',
	},
	tag: {
		id: 'search_result_type_tag',
		defaultMessage: 'Tag',
		description: 'Label for the tag search result type',
	},
	learning: {
		id: 'search_result_type_learning',
		defaultMessage: 'Learning',
		description: 'Label for the learning search result type',
	},
	unrecognised: {
		id: 'search_result_type_unrecognised',
		defaultMessage: 'Unrecognised',
		description: 'Label for the unrecognised search result type',
	},
	document: {
		id: 'search_result_type_document',
		defaultMessage: 'Document',
		description: 'Label for the document search result type',
	},
	spreadsheet: {
		id: 'search_result_type_spreadsheet',
		defaultMessage: 'Spreadsheet',
		description: 'Label for the spreadsheet search result type',
	},
	presentation: {
		id: 'search_result_type_presentation',
		defaultMessage: 'Presentation',
		description: 'Label for the presentation search result type',
	},
	'sharepoint-document': {
		id: 'search_result_type_sharepoint_document',
		defaultMessage: 'Sharepoint Document',
		description: 'Label for the sharepoint document search result type',
	},
	message: {
		id: 'search_result_type_message',
		defaultMessage: 'Message',
		description: 'Label for a slack message search result type',
	},
	repository: {
		id: 'search_result_type_repository',
		defaultMessage: 'Repository',
		description: 'Label for a repository search result type',
	},
	'pull-request': {
		id: 'search_result_type_pull_request',
		defaultMessage: 'Pull Request',
		description: 'Label for a pull request search result type',
	},
	commit: {
		id: 'search_result_type_commit',
		defaultMessage: 'Commit',
		description: 'Label for a commit search result type',
	},
	branch: {
		id: 'search_result_type_branch',
		defaultMessage: 'Branch',
		description: 'Label for a branch search result type',
	},
	file: {
		id: 'search_result_type_file',
		defaultMessage: 'File',
		description: 'Label for a file search result type',
	},
	channel: {
		id: 'search_result_type_channel',
		defaultMessage: 'Channel',
		description: 'Label for a message channel search result type',
	},
	component: {
		id: 'search_result_type_component',
		defaultMessage: 'Component',
		description: 'Label for a component search result type',
	},
	'work-item': {
		id: 'search_result_type_work_item',
		defaultMessage: 'Work Item',
		description: 'Label for a work item search result type',
	},
	card: {
		id: 'search_result_type_card',
		defaultMessage: 'Card',
		description: 'Label for a card search result type',
	},
	incident: {
		id: 'search_result_type_incident',
		defaultMessage: 'Incident',
		description: 'Label for the incident search result type',
	},
	focus_area: {
		id: 'search_result_type_focus_area',
		defaultMessage: 'Focus area',
		description: 'Label for a focus area search result type',
	},
	focus_area_status_update: {
		id: 'search_result_type_focus_area_status_update',
		defaultMessage: 'Focus area update',
		description: 'Label for a focus area status update search result type',
	},
	organization: {
		id: 'search_result_type_organization',
		defaultMessage: 'Organization',
		description: 'Label for a organization search result type',
	},
	organization_status_update: {
		id: 'search_result_type_organization_status_update',
		defaultMessage: 'Organization update',
		description: 'Label for a organization status update search result type',
	},
	ask: {
		id: 'search_result_type_ask',
		defaultMessage: 'Ask',
		description: 'Label for an ask search result type',
	},
	email: {
		id: 'search_result_type_email',
		defaultMessage: 'Email',
		description: 'Label for an email search result type',
	},
	gliffy: {
		id: 'search_result_type_gliffy',
		defaultMessage: 'Gliffy Diagram',
		description: 'Label for a gliffy search result type',
	},
	deal: {
		id: 'search_result_type_deal',
		defaultMessage: 'Deal',
		description: 'Label for a deal search result type',
	},
	'customer-org': {
		id: 'search_result_type_customer_org',
		defaultMessage: 'Customer Organization',
		description: 'Label for a customer organization search result type',
	},
	'data-table': {
		id: 'search_result_type_data_table',
		defaultMessage: 'Data table',
		description: 'Label for a data table search result type',
	},
	'customer-contact': {
		id: 'search_result_type_customer_contact',
		defaultMessage: 'Customer contact',
		description: 'Label for a customer contact search result type',
	},
	object: {
		id: 'search_result_type_object',
		defaultMessage: 'Object',
		description: 'Label for an object search result type',
	},
	schema: {
		id: 'search_result_type_schema',
		defaultMessage: 'Schema',
		description: 'Label for a schema search result type',
	},
	type: {
		id: 'search_result_type_type',
		defaultMessage: 'Object type',
		description: 'Label for a type search result type',
	},
	position: {
		id: 'search_result_type_position',
		defaultMessage: 'Position',
		description: 'Label for a position search result type',
	},
	video: {
		id: 'search_result_type_video',
		defaultMessage: 'Video',
		description: 'Label for a video search result type',
	},
	task: {
		id: 'search_result_type_task',
		defaultMessage: 'Task',
		description: 'Label for the task search result type (Jira issue type)',
	},
	epic: {
		id: 'search_result_type_epic',
		defaultMessage: 'Epic',
		description: 'Label for the epic search result type (Jira issue type)',
	},
	bug: {
		id: 'search_result_type_bug',
		defaultMessage: 'Bug',
		description: 'Label for the bug search result type (Jira issue type)',
	},
	story: {
		id: 'search_result_type_story',
		defaultMessage: 'Story',
		description: 'Label for the story search result type (Jira issue type)',
	},
	'sub-task': {
		id: 'search_result_type_sub_task',
		defaultMessage: 'Sub-task',
		description: 'Label for the sub-task search result type (Jira issue type)',
	},
	subtask: {
		id: 'search_result_type_subtask',
		defaultMessage: 'Sub-task',
		description: 'Label for the subtask search result type (Jira issue type, alternate key)',
	},
	improvement: {
		id: 'search_result_type_improvement',
		defaultMessage: 'Improvement',
		description: 'Label for the improvement search result type (Jira issue type)',
	},
	'new feature': {
		id: 'search_result_type_new_feature',
		defaultMessage: 'New feature',
		description: 'Label for the new feature search result type (Jira issue type)',
	},
	change: {
		id: 'search_result_type_change',
		defaultMessage: 'Change',
		description: 'Label for the change search result type (Jira issue type)',
	},
	problem: {
		id: 'search_result_type_problem',
		defaultMessage: 'Problem',
		description: 'Label for the problem search result type (Jira issue type)',
	},
	'service request': {
		id: 'search_result_type_service_request',
		defaultMessage: 'Service request',
		description: 'Label for the service request search result type (Jira issue type)',
	},
});

export type SearchResultTypeMessageKey = keyof typeof messages;
